<template lang="pug">
.contract-and-do-item
  el-row(v-if="index !== 0")
    el-col(:span="8" :offset="3")
      hr(style="border: 0.5px solid #ccc")
  el-row
    el-col(:span="4") {{ item.is_increment ? $t('增量DO号') : $t('DO号') }}
    el-col(:span="10") {{ item.do_no }}
  el-row
    el-col(:span="4") {{ $t('合同号') }}
    el-col(:span="10") {{ item.contract_no }}
  el-row
    el-col(:span="4") {{ $t('合同') }}
    el-col(:span="10")
      a(
        :href="item.file_download_path"
        target="_blank"
      ) {{ item.file_name }}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number
    }
  }
}
</script>
